// extracted by mini-css-extract-plugin
export default {"content":"ooo52WkcuqwmIuR62KM7"};